module.exports = __webpack_public_path__ + "static/media/n2.0c4f6459.png";